import isFuture from 'date-fns/isFuture';
import { DEBOUNCE_TIME } from '../../../constants';
import { saveApplication, debounce as saveApidebounce } from '../../../utilities';
import snackbar from "components/snackbar";
import { format } from 'date-fns';
import { getAvailableUnits } from '../../../utils';
import validate from '../../../validations';

export default {
  refreshOn: ({ moveInInformation }) => [moveInInformation],
  init: (fullState, stateManager, internalStateSetter) => {
    saveApidebounce(() => saveApplication(stateManager), DEBOUNCE_TIME);
  },
  'MoveInInfo.Wrapper.ExpectedMoveIn': ({ moveInInformation, selectedDate }, stateManager) => {
    const { isEditMode, previousMoveInDate, language } = stateManager.store.getState()

    const formatSelectedDate = format(selectedDate, 'yyyy-MM-dd')

    let notFutureDate = !isFuture(selectedDate)
    if (previousMoveInDate === formatSelectedDate) notFutureDate = false

    if (isEditMode && notFutureDate) {
      snackbar({
        message: language.movein_errors.allowed_date,
        args: { type: 'error' }
      })
      return
    }

    const updatedMoveInInformation = { ...moveInInformation, moveInDate: selectedDate, moveInDateError: '', hasError: false };
    stateManager.setMoveInInformation(updatedMoveInInformation);

    !isEditMode && validate(500);
  },
  'MoveInInfo.Wrapper.FloorPlanDropdown': ({ moveInInformation, selectedOptionId, property, availableUnits  }, stateManager) => {
    const updatedMoveinInfo = { ...moveInInformation, selectedFloorPlan: selectedOptionId, selectedFloorPlanError: '', hasError: false}
    const units = getAvailableUnits({ property, moveInInformation: updatedMoveinInfo, availableUnits })
    if (units.length === 0 && !!availableUnits?.length) {
      snackbar({
        message: 'No available units for the current selection, please choose another floor plan or select a later move in date',
        args: { type: 'error' }
      })
    }

    stateManager.setMoveInInformation(updatedMoveinInfo);
    validate(500);
  },
  'MoveInInfo.Wrapper.UnitDropdown': ({ moveInInformation, selectedOptionId }, stateManager) => {
    const updatedMoveinInfo = { ...moveInInformation, selectedUnitNumber: selectedOptionId, selectedUnitNumberError: '',hasError: false }
    stateManager.setMoveInInformation(updatedMoveinInfo);

    validate(500);
  }
};
